import ImageWMS from 'ol/source/ImageWMS';
import TileWMS from 'ol/source/TileWMS';

import { getWMS } from './layers';
import { map } from './tools';

export const getLayerById = (id) => {
  const layers = map.getLayers();
  const nl = layers.getLength();
  for (let i = 0; i < nl; i++) {
    const l = layers.item(i);
    if (l.get('id') === id) return l;
  }
};

export const highlightLayer = (layer, highlight) => {
  layer.getSource().forEachFeature(f => f.set('highlight', highlight));
};

const isWMS = (layer) => {
  const s = layer.getSource();
  return (s instanceof ImageWMS || s instanceof TileWMS);
};

export const getFeatureInfo = (coord, view, wms) => new Promise((y, n) => {
  const url = wms.getSource().getFeatureInfoUrl(
    coord,
    view.getResolution(),
    view.getProjection().getCode(),
    { INFO_FORMAT: 'text/html' }
  );
  if (url) {
    fetch(url).then(r => r.text()).then(htmlString => {
      if (htmlString) {
        const parser = new DOMParser();
        y(parser.parseFromString(htmlString, 'text/html'));
      } else y(htmlString); // empty string
    }).catch(err => n(err));
  } else return n('Could not obtain url from WMS');
});

export const getSpecificFeatureInfo = (s, name, c, v) => new Promise((y, n) => {
  const ar5 = (name === 'ar5');
  const wms = ar5 ? getWMS('ar5') : getWMS('grunnkart');
  // console.log(wms.get('id'));
  const info = {};
  getFeatureInfo(c, v, wms).then(html => {
    if (html) {
      const tds = html.getElementsByTagName('td');
      for (let i = 0; i < tds.length / 2; i++) {
        const ktd = tds[2 * i];
        const vtd = tds[2 * i + 1];
        if (!vtd) break;
        const key = ktd.innerHTML;
        const value = vtd.innerHTML;
        if (s.indexOf(key) > -1) info[key] = value;
      }
    } // else outside WMS scale
    y(info);
  }).catch(e => n(e));
});

export const getWMSes = (map) => {
  const wmses = [];
  map.getLayers().forEach(l => { if (isWMS(l)) wmses.push(l); });
  return wmses;
};

export const visibleComputationArea = (id) => {
  const wms = getWMS('authorized');
  const legend = document.getElementById(`authorizedLegend`);
  if (id) {
    const p = wms.getSource().getParams();
    p.request_id = id;
    wms.getSource().updateParams(p);
    map.addLayer(wms);
    if (legend) legend.hidden = false;
  } else {
    map.removeLayer(wms);
    if (legend) legend.hidden = true;
  }
};
